var React = require('react');

function DropIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#16AED1","key":0}),React.createElement("path",{"fill":"#FFF","d":"M13,6 L12.9998932,14.585 L16.2928932,11.2928932 L17.7071068,12.7071068 L12,18.4142136 L6.29289322,12.7071068 L7.70710678,11.2928932 L10.9998932,14.585 L11,6 L13,6 Z","transform":"translate(8 8)","key":1})]));
}

DropIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = DropIcon;

DropIcon.default = DropIcon;
